
import React, { useEffect, useState, useCallback } from "react";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { clearCityList, fetchCityData, selectCity } from "../../redux/actions/citiesAction";
import { fetchJobTitleData } from "../../redux/actions/JobTitleActions";
import { customStylesForCity } from "../../customStylesForCity";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import bannnerimg from "../../assets/images/bannerimg.jpeg"
import { customStyles } from "../../selectStyles";


function FormContent() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const [cityId, setCityId] = useState("");
	const [jobTitleId, setJobTitleId] = useState("");

	const { cityList,loading } = useSelector((state) => state.cities);
	const { jobTitleList } = useSelector((state) => state.jobTitle);
	const [filteredCityList, setFilteredCityList] = useState([]);
    const [isLoading,setIsLoading] = useState(true)
	 useEffect(() => {
		const params = new URLSearchParams(location.search);
		const cityIdParam = params.get("cityId") || "";
		const jobTitleIdParam = params.get("jobTitle") || "";

		setCityId(cityIdParam);
		setJobTitleId(jobTitleIdParam);
         
	 if (!cityList.length) {  // Prevent unnecessary fetching
			dispatch(fetchCityData());
		}
	
		if (!jobTitleList.length) {
			dispatch(fetchJobTitleData());
		}
	
	}, [dispatch, location.search]);

 
	const handleCitySelect = (selectedOption) => {
		console.log("selectedOption", selectedOption);
		setCityId(selectedOption ? selectedOption.value : "");
		dispatch(selectCity(selectedOption ? selectedOption.value : ""));
	 
	};
	const handleCityInputChange = (inputValue) => {
		console.log("inputValue", inputValue);
		dispatch(fetchCityData(inputValue));
	};
 
	const handleJobTitle = (selectedOption) => {
		setJobTitleId(selectedOption ? selectedOption.value : "");
	};

	const handleSearchInputChange = (inputValue) => {
		dispatch(fetchJobTitleData(inputValue));
	};

	const queryParams = new URLSearchParams();
	if (jobTitleId) queryParams.set("jobTitle", jobTitleId);
	if (cityId) queryParams.set("cityId", cityId);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!jobTitleId && !cityId) {
			toast.error("Please select a city or enter a job title.");
			return;
		}
		const queryParams = new URLSearchParams();
		if (jobTitleId) queryParams.set("jobTitle", jobTitleId);
		if (cityId) queryParams.set("cityId", cityId);
		 navigate(`/Jobs?${queryParams.toString()}`);
	};
	const handleDropdownOpen = () => {
		dispatch(fetchCityData()); // Load full list again when dropdown opens
};

const options = loading
    ? [{ label: "Loading...", value: "" }]
    : cityList;
	
	return (
		<>

			<div className="content formContent mobile-dropdown mobile-city-syle pt-4 text-center m-auto banner-search-cont" style={{ width: '70%' }}>
				<h2 className="text-dark f-600 mb-3">Navigate the Path to Possibilities</h2>
				<p className="text-dark mb-4">Step into a career that aligns with your purpose. Khoj bridges the gap between your potential and the right opportunities—connecting you to roles that align with your goals and inspire you to achieve more.</p>
				<div className="form-sl me-0">
					<form onSubmit={handleSubmit}>
						<div className="row-group-search home1 w-100">
							<div className="form-group-2 col-5 Dropdown-menu-dark">
								<ReactSelect
									options={options}
									onChange={handleCitySelect}
									value={cityList.find((option) => option.value === cityId) || null}
									onInputChange={handleCityInputChange}
									onMenuOpen={handleDropdownOpen}
									placeholder="Search & Select City" 
									classNamePrefix="react-select"
									className="form-control banner-city"
									isClearable
									// isDisabled={loading}
									styles={customStyles}
								/>
							</div>
							<div className="form-group-1 col-4 Dropdown-menu-dark">
								<ReactSelect
									options={jobTitleList}
									onChange={handleJobTitle}
									value={jobTitleList.find((option) => option.value === jobTitleId) || null}
									onInputChange={handleSearchInputChange}
									placeholder="Search Jobs" 
									classNamePrefix="react-select"
									className="form-control banner-city"
									isClearable
									styles={customStyles}
								/>
							</div>
							<div className="form-group-4 ms-2 d-flex justify-content-center form-group-FJ">
								<button
									type="submit"
									className="btn khojPrimaryBtn"
									style={{ width: "137px", height: "50px" }}
								>
									Search
								</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</>
	);
}

export default FormContent;
